import { useCallback, useState } from 'react';
import useQueryParams from '../../../hooks/useQueryParams';

type Result = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  churchAccountId?: string;
};

export function useConnectChurchAccountModalControl(): Result {
  const { churchAccountId } = useQueryParams();
  const [isOpen, setIsOpen] = useState(Boolean(churchAccountId));

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return { isOpen, open, close, churchAccountId };
}
